import React, { useEffect, useState } from 'react';
import { useFormCompletion } from '../Context/FormCompletionContext';
import { useNavigate } from 'react-router-dom';

const CustomerInfoForm = () => {
  const { markFormAsCompleted, saveFormData, formData } = useFormCompletion();
  const navigate = useNavigate();
  const [newFormData, setNewFormData] = useState({
    email: '',
    whatsApp: '',
    phoneNumber: '',
    firstName: '',
    lastName: '',
  });

  const [errors, setErrors] = useState({});
  const [isFormValid, setIsFormValid] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setNewFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));

    // Clear errors as the user types
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: '',
    }));
  };

  const validateField = (name, value) => {
    if (!value) {
      return 'This field is required.';
    }
    if (name === 'email' && !/\S+@\S+\.\S+/.test(value)) {
      return 'Please enter a valid email.';
    }
    if ((name === 'phoneNumber' || name === 'whatsApp') && !/^\d+$/.test(value)) {
      return 'Please enter a valid number.';
    }
    return '';
  };

  const validateForm = () => {
    const newErrors = {};
    Object.keys(newFormData).forEach((key) => {
      const error = validateField(key, newFormData[key]);
      if (error) newErrors[key] = error;
    });
    setErrors(newErrors);
    setIsFormValid(Object.keys(newErrors).length === 0);
  };

  useEffect(() => {
    if (formData.customer_details) {
      const savedData = formData.customer_details;
      setNewFormData((prevFormData) => ({
        ...prevFormData,
        ...savedData,
      }));
    }
  }, [formData.customer_details]);

  useEffect(() => {
    validateForm(); // Validate form on initial load or field changes
  }, [newFormData]);

  const onSubmit = (event) => {
    event.preventDefault();
    validateForm();
    if (!isFormValid) return;

    saveFormData('customer_details', newFormData);
    markFormAsCompleted('delivery_details');
    navigate('/order/delivery_details');
  };

  return (
    <div>
      <h2 className="text-xl font-semibold text-[#551e19] mb-4">
        Customer Information
      </h2>
      <form
        className="grid grid-cols-1 sm:grid-cols-2 gap-6"
        onSubmit={onSubmit}
        noValidate
      >
        {['firstName', 'lastName', 'email', 'phoneNumber', 'whatsApp'].map((field, index) => (
          <div key={index} className="flex flex-col relative">
            <label className="mb-1 text-sm">
              {field
                .replace(/([A-Z])/g, ' $1')
                .replace(/^./, (str) => str.toUpperCase())}{' '}
              <span className="text-red-500">*</span>
            </label>
            <input
              type={field === 'email' ? 'email' : 'text'}
              name={field}
              value={newFormData[field]}
              onChange={handleChange}
              onBlur={() =>
                setErrors((prevErrors) => ({
                  ...prevErrors,
                  [field]: validateField(field, newFormData[field]),
                }))
              }
              className={`border rounded-lg p-2 text-sm focus:ring-[#551e19] focus:border-[#551e19] outline-none `}
              required
            />
            {errors[field] && (
              <span className="text-red-500 text-[8px] mt-1 absolute top-full">
                {errors[field]}
              </span>
            )}
          </div>
        ))}

        <button
          type="submit"
          className={`col-span-1 sm:col-span-2 bg-[#f7c89c] text-white font-semibold py-2 rounded-full max-w-max px-8 mx-auto mt-5 transition ${
            !isFormValid ? 'opacity-50 cursor-not-allowed' : 'hover:bg-[#efad70]'
          }`}
          disabled={!isFormValid}
        >
          CONTINUE
        </button>
      </form>
    </div>
  );
};

export default CustomerInfoForm;